import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResetSettings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17.202343,
	height: 14.702343,
	viewBox: "0 0 17.202343 14.702343",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m2.7515625.15000007c-1.4294397 0-2.60156255 1.16821683-2.60156255 2.59765633v9.2031246c0 1.42944 1.17212285 2.601563 2.60156255 2.601563h5.4511719V13.251563H2.7515625c-.7317272 0-1.3007812-.569054-1.3007812-1.300782V2.7476564c0-.7317273.569054-1.2988281 1.3007812-1.2988282H14.452734c.731728 0 1.298829.5671009 1.298829 1.2988282v2.9550781h1.300781V2.7476564c0-1.4294395-1.17017-2.59765633-2.59961-2.59765633z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		transform: "translate(-8.6914339 -2.1223497)",
		children: [/* @__PURE__ */ _jsx("line", {
			x1: 19.643778,
			y1: 10.574694,
			x2: 25.143778,
			y2: 16.074694
		}), /* @__PURE__ */ _jsx("line", {
			x1: 25.143778,
			y1: 10.574694,
			x2: 19.643778,
			y2: 16.074694
		})]
	})]
});
export default SvgResetSettings;
